/**
 * Created by chenzheyu on 2017/6/16.
 */
import XKnavTabs from './src/navTabs.vue'

XKnavTabs.intall = function (Vue) {
  Vue.component(XKnavTabs.anme, XKnavTabs)
}

export default XKnavTabs



// WEBPACK FOOTER //
// ./src/components/module/navTbas/index.js